import { GearInstance, StepperStep } from 'types';
import { saveBlockedRentDates } from 'api';
import { getCommonFormProps } from './commonData';

export const getBlockedDatesStep = (
  instance: GearInstance,
  onPass: (data: any, toDraft?: boolean) => void,
): StepperStep => ({
  stepName: 'Blocked Dates',
  onPass: async (data: any) => {
    onPass(data);
  },
  formProps: {
    buttonCaption: 'Save & Next',
    isSlimFooter: false,
    ...getCommonFormProps(onPass),
    fields: [
      {
        type: 'secondTitle',
        fieldName: 'step_title',
        value: 'Blocked Dates',
      },
      {
        type: 'subtitle',
        fieldName: 'subtitle',
        value: 'Select your gear\'s blocked dates',
      },
      {
        type: 'description',
        fieldName: 'step_description',
        value: 'Gear will be shown as "unavailable" during these dates.',
      },
      {
        type: 'calendarClickablePicker',
        fieldName: 'dates_range',
        id: instance.id,
        value: instance.blocked_rent_dates,
        postDateRangeCallback: saveBlockedRentDates,
      },
      ...(instance.account_type==='business' ? [] : [
        {
          type: 'availableTimePicker',
          value: instance.meeting,
        },
      ]),
    ],
  },
});
